module.exports = __webpack_public_path__ + "img/cisco_webex.23c89e5e.png";